import { ReactElement } from 'react'
import { nanoid } from 'nanoid'
import { cloneElement } from 'react'

export const generateSkeletons = (component: ReactElement, amount: number): ReactElement[] => {
  let arr = []

  for (let i = 0; i < amount; i++) {
    arr.push(cloneElement(component, { key: nanoid() + i }))
  }

  return arr
}
